import { DEFAULT_APPOINTMENT_COLOR, TIMES } from '../constants';
import { getHour } from './dateUtils';

export const filterAppointments = ({ appointments, creatorIds, tagIds }) => {
  let filteredAppointments = appointments;

  if (creatorIds.length > 0) {
    filteredAppointments = filteredAppointments.filter((appointment) =>
      creatorIds.includes(appointment.creator?.id)
    );
  }

  if (tagIds.length > 0) {
    filteredAppointments = filteredAppointments.filter((appointment) =>
      appointment.tags.some((tag) => tagIds.includes(tag.id))
    );
  }

  return filteredAppointments;
};

export const getAppointmentColor = (appointment) =>
  appointment.tags[0]?.color ?? DEFAULT_APPOINTMENT_COLOR;

// Returns a hash that organizes appointments by date:
// { date: [appointments] }
export const getAppointmentsByDate = ({ appointments, dates }) => {
  const appointmentsByDate = {};

  dates.forEach((date) => {
    appointmentsByDate[date.toDateString()] = [];
  });

  appointments.forEach((appointment) => {
    const dateStr = new Date(appointment.startAt).toDateString();
    appointmentsByDate[dateStr]?.push(appointment);
  });

  return appointmentsByDate;
};

// Returns a hash that organizes appointments by time and date:
// { time: { date: [appointments] } }
export const getAppointmentsByDateTime = ({ appointments, dates }) => {
  const appointmentsByDateTime = {};

  TIMES.forEach((time) => {
    appointmentsByDateTime[time] = {};

    dates.forEach((date) => {
      appointmentsByDateTime[time][date.toDateString()] = [];
    });
  });

  appointments.forEach((appointment) => {
    const date = new Date(appointment.startAt);
    const dateStr = date.toDateString();
    const hour = date.getHours();
    const time = TIMES.find((time) => getHour(time) === hour);

    appointmentsByDateTime[time][dateStr]?.push(appointment);
  });

  return appointmentsByDateTime;
};
